<template>
  <div class="GoldenPandaClub container_w dis_bo">
      <bread-crumb></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <nav-book></nav-book>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader/PageHeader";
import NavBook from "@/components/HomeComponents/HomeNav/NavBook";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
export default {
  components: {
    PageHeader,
    NavBook,
    BreadCrumb
  },
  name: "GoldenPandaClub",
  data() {
    return {
      headerTitle:'Book a Flight'
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
    
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped></style>
